import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * BackInStockSubscriptionsApi - axios parameter creator
 * @export
 */
const BackInStockSubscriptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary The most recent back-in-stock subscriptions (up to BizWeb.NC.API.Controllers.BackInStockSubscriptionsController.MaxRows), newest first. Not cached: the grid must show a subscription the moment it is made. (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/BackInStockSubscriptions/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BackInStockSubscriptionsApi - functional programming interface
 * @export
 */
const BackInStockSubscriptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BackInStockSubscriptionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary The most recent back-in-stock subscriptions (up to BizWeb.NC.API.Controllers.BackInStockSubscriptionsController.MaxRows), newest first. Not cached: the grid must show a subscription the moment it is made. (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackInStockSubscriptionsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BackInStockSubscriptionsApi - factory interface
 * @export
 */
const BackInStockSubscriptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BackInStockSubscriptionsApiFp(configuration);
    return {
        /**
         *
         * @summary The most recent back-in-stock subscriptions (up to BizWeb.NC.API.Controllers.BackInStockSubscriptionsController.MaxRows), newest first. Not cached: the grid must show a subscription the moment it is made. (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BackInStockSubscriptionsApi - object-oriented interface
 * @export
 * @class BackInStockSubscriptionsApi
 * @extends {BaseAPI}
 */
class BackInStockSubscriptionsApi extends BaseAPI {
    /**
     *
     * @summary The most recent back-in-stock subscriptions (up to BizWeb.NC.API.Controllers.BackInStockSubscriptionsController.MaxRows), newest first. Not cached: the grid must show a subscription the moment it is made. (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackInStockSubscriptionsApi
     */
    getAll(options) {
        return BackInStockSubscriptionsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
}

export { BackInStockSubscriptionsApi, BackInStockSubscriptionsApiAxiosParamCreator, BackInStockSubscriptionsApiFactory, BackInStockSubscriptionsApiFp };
//# sourceMappingURL=back-in-stock-subscriptions-api.js.map
